import { Fragment } from "react";
import { useParams } from "react-router-dom";
import { FiltersProvider } from "../../../../../components/providers/FiltersProvider";
import VehicleRefueling from "./VehicleRefueling";

const VehicleRefuelingWrapper = () => {
    const { id } = useParams<{ id: string }>();

    // Default filters for vehicle refueling
    const defaultFilterFilters = {
        vehicle_id: id // Always filter by the current vehicle
    };

    return (
        <Fragment>
            <FiltersProvider defaultFilterFilters={defaultFilterFilters}>
                <VehicleRefueling />
            </FiltersProvider>
        </Fragment>
    );
};

export default VehicleRefuelingWrapper;